<mat-card>
    <mat-card-header>
        <mat-card-title-group>
            <mat-card-title>
                <h2 id="editAmountDueDialogTitle" class="no-margin">Update BalanceDue Amount - Zero Revenue</h2>
            </mat-card-title>
        </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="form">
            <div class="item-1">
                <i class="material-icons">info_outline</i>
                Enter a New Pay Amount...
            </div>
            <dl>
                <dt>Revenue ID:</dt>
                <dd>{{ receivable.id }}</dd>
                <dt>Revenue Code:</dt>
                <dd>{{ receivable.typeCode }}</dd>
                <dt>Fee Description:</dt>
                <dd>{{ receivable.typeDesc }}</dd>
                <dt>Payment Owner:</dt>
                <dd>{{ receivable.paymentOwner }}</dd>
                <dt>Due Date:</dt>
                <dd>{{ receivable.dueDate | date: 'MM/dd/yyyy' }}</dd>
                <dt>Current Amount Due:</dt>
                <dd>{{ receivable.balanceDue }}</dd>
            </dl>
            <mat-form-field appearance="outline">
                <mat-label>New Pay Amount</mat-label>
                <input id="newBalanceDue" type="number" matInput formControlName="newBalanceDue">
            </mat-form-field>
        </form>
    </mat-card-content>
    <mat-dialog-actions align="end">
        <button mat-flat-button id="save_btn" (click)="saveClick()" aria-label="Save">Save</button>
        <button mat-flat-button id="close_btn" (click)="closeDialog()" aria-label="Cancel">Cancel</button>
    </mat-dialog-actions>
</mat-card>

